import {
  HTTP_GETBUDGETFA_FETCHING,
  HTTP_GETBUDGETFA_SUCCESS,
  HTTP_GETBUDGETFA_FAILED,
  HTTP_RESET_GETBUDGETFA,
} from "src/Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETFA_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETFA_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETFA_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
